<template>
  <div>
    <div v-if="regularize === 'true'">
      <div class="cabecalho">
        <h3 class="title-content m-0">Irregularidades</h3>
      </div>
      <v-stepper v-model="level" vertical>
        <v-stepper-step color="#000" step="1">
          <span class="title-stepper">Selecionar Irregularidade</span>
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-form ref="formRegularize">
            <v-row>
              <v-col cols="12">
                <v-combobox
                    class="input-activation"
                    v-model="vehicle"
                    :items="vehicles"
                    item-text="plate"
                    label="Pesquisar Placa"
                    required
                    @change="searchNotifications(vehicle)"
                    @keyup="onKeyUp"
                    return-object
                    :loading="loading"
                ></v-combobox>
              </v-col>
            </v-row>
          </v-form>
          <select-notification
              :notificationsPlate="notifications"
              v-show="(vehicle) && ((vehicle.plate === undefined && vehicle.length === 7) || (vehicle.plate !== undefined && vehicle.plate.length === 7))"
              v-on:update:notification="payment.notification = $event"
          >
          </select-notification>
          <v-btn v-if="notifications.length > 0" class="btn-confirm float-right" text @click="level = 2">Continuar
          </v-btn>
        </v-stepper-content>
        <v-stepper-step color="#08437B" step="2">
          <span class="title-stepper">Selecionar Pagamento</span>
        </v-stepper-step>
        <v-stepper-content step="2">
          <method-payment-v2
              v-if="payment && payment.notification && payment.notification.price"
              :transaction-type="17"
              :validPayment="validPayment"
              :options="{
                            label:'VALOR DA REGULARIZAÇÃO',
                            price:payment.notification.price,
                            price_disabled:true
                        }"
              v-on:update:validated="createOrder($event)"
              @loading="loading = $event"
          />
          <v-btn class="btn-confirm float-right" :loading="loading" text @click="validPayment = !validPayment">
            Continuar
          </v-btn>
          <v-btn class="btn-cancel float-right" @click.prevent="refreshPage()" text>Cancelar</v-btn>
        </v-stepper-content>
        <v-stepper-step color="#08437B" step="3"><span class="title-stepper">Confirmar Pagamento</span>
        </v-stepper-step>
        <v-stepper-content step="3">
          <resume-regularize :details="payment" :order="order"/>
          <div class="button-group">
            <v-btn class="btn-cancel" :loading="loading" @click.prevent="refreshPage()" text>Cancelar</v-btn>
            <v-btn class="btn-confirm-outlined" :loading="loading" @click.prevent="level = 1" text>
              <i class="fas fa-pen mr-1"></i> Corrigir
            </v-btn>
            <v-btn class="btn-confirm" :loading="loading" @click.prevent="preConfirm()" text>Finalizar Pagamento</v-btn>
          </div>
        </v-stepper-content>
      </v-stepper>

      <pix-dialog :order="order"/>
      <debit-dialog :order="order"/>

      <v-snackbar
          v-model="message_success"
          :color="'success'"
          :multi-line="true"
          :right="true"
          :timeout="2000"
          :top="true"
          class="snackbar-success"
      >
        <span><i class="fas fa-check mr-2"></i> Pagamento realizado com sucesso!</span>
      </v-snackbar>

      <v-dialog v-model="verificationError" persistent max-width="400">
        <v-card>
          <v-card-title>
            <i class="fas fa-window-close ml-auto icon-close-modal" @click.prevent="verificationError = false"></i>
          </v-card-title>
          <v-card-text>
            <verify-phone-form
                title="Atenção"
                :error-msg="errorBuy"
                @continue-action="cleanError"
            ></verify-phone-form>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="addressError" persistent max-width="400">
        <v-card>
          <v-card-title>
            <span class="headline">Atenção</span>
            <v-spacer></v-spacer>
            <i class="fas fa-window-close ml-auto icon-close-modal" @click.prevent="addressError = false"></i>
          </v-card-title>
          <v-card-text>
            <profile
                :error-msg="errorBuy"
                :is-modal="true"
                @continue-action="cleanError"
            ></profile>
          </v-card-text>
        </v-card>
      </v-dialog>

      <generic-error-dialog
          @cleanError="cleanError"
          :error-text="errorBuy"
          :visible="genericError"
      />
    </div>
    <order ref="order"/>
  </div>
</template>

<script>
import SelectNotification from '../components/SelectNotification';
import ResumeRegularize from '../components/ResumeRegularize';
import _ from 'lodash';
import axios from 'axios';
import MethodPaymentV2 from "@/components/MethodPayment/MethodPaymentV2.vue";
import Order from "@/components/MethodPayment/Order.vue";
import PixDialog from "@/components/MethodPayment/PixDialog.vue";
import DebitDialog from "@/components/MethodPayment/DebitDialog.vue";
import GenericErrorDialog from "@/components/GenericErrorDialog.vue";
import Profile from "@/views/Profile.vue";
import VerifyPhoneForm from "@/components/VerifyPhoneForm.vue";

export default {
  name: "Regularize",
  components: {
    VerifyPhoneForm,
    Profile,
    GenericErrorDialog,
    DebitDialog,
    PixDialog,
    Order,
    MethodPaymentV2,
    SelectNotification,
    ResumeRegularize,
  },
  data: function () {
    return {
      loading: false,
      level: 1,
      order: null,
      payment: {},
      message_success: false,
      errorBuy: null,
      verificationError: false,
      addressError: false,
      genericError: false,
      validPayment: null,
      vehicle: {
        plate: ''
      },
      vehicles: [],
      notifications: [],
      plate: null
    }
  },
  async mounted() {
    try {
      this.loading = true;
      const {data: {data: vehicles}} = await axios.get('/api/users/driver/me/plate').catch(error => {
        this.handleCatchError(error);
      });
      this.vehicles = vehicles;
      if (this.vehicles.length > 0) {
        this.vehicle = this.vehicles[0];
        this.searchNotifications(this.vehicle);
      }
    } catch (e) {
      this.handleCatchError(e);
    }

    this.loading = false;
  },
  methods: {
    async createOrder(methodPayment) {
      try {
        this.payment.method_payment = methodPayment;

        this.payment.body = {
          notifications: [this.payment.notification.id],
          user_id: this.user_id,
        }

        this.loading = true;
        this.order = await this.$refs.order.createOrder(17, this.payment);
        this.level = 3;
      } catch (e) {
        this.handleCatchError(e)
      }
      this.loading = false;
    },
    async preConfirm() {
      try {
        this.loading = true;
        this.order = await this.$refs.order.preConfirmOrder();

        if (this.order.payment_form.id === 5) {
          window.open(this.order.collection_document.file);
          setTimeout(function () {
            location.reload();
          }, 2000);
          return;
        }

        if ([
          2,
          4
        ].includes(this.order.payment_form.id)) {
          await this.$refs.order.confirmOrder();
          this.message_success = true;
          setTimeout(function () {
            location.reload();
          }, 1000);
          return;
        }
      } catch (e) {
        this.handleCatchError(e)
      }
      this.loading = false;
    },
    onKeyUp(e) {
      const plate = e.target.value.toUpperCase();
      this.searchDebounce(plate, this);
    },
    searchDebounce: _.debounce((plate, vm) => {
      if (plate) {
        vm.notifications = [];
        vm.loading = true;
        vm.genericError = null;
        axios.get('/api/audit/notification', {
          params: {
            status: 2,
            plate
          }
        })
            .then(res => {
              vm.vehicle = {
                plate,
              }
              vm.notifications = res.data.data;
              vm.genericError = null;
            })
            .catch(error => {
              vm.handleCatchError(error);
            })
            .finally(() => {
              vm.loading = false;
            });
      }
    }, 1500),
    searchNotifications(vehicle) {
      if (vehicle && vehicle.plate !== undefined) {
        this.notifications = [];
        this.loading = true;
        this.genericError = null;
        axios.get('/api/audit/notification', {
          params: {
            status: 2,
            plate: vehicle.plate
          }
        })
            .then(res => {
              this.vehicle.plate = vehicle.plate;
              this.notifications = res.data.data;
              this.genericError = null;
            })
            .catch(error => {
              this.handleCatchError(error);
            })
            .finally(() => {
              this.loading = false;
            });
      }
    },
    handleVerifyPhoneDialog() {
      this.verificationError = false;
      this.errorBuy = null;
    },
    handleVerifyProfileDataDialog() {
      this.addressError = false;
      this.errorBuy = null;
    },
    handleCatchError(error) {
      this.errorBuy = this.getErrorMessage(error);
      if (error.response.data.type === 'UserNotVerified') {
        this.verificationError = true;
      } else if (error.response.data.type === 'ValidationException') {
        this.addressError = true;
      } else {
        this.genericError = true;
      }
    },
    cleanError() {
      this.errorBuy = null;
      this.verificationError = false;
      this.addressError = false;
      this.genericError = false;
    },
  },
  computed: {
    user_id: function () {
      return JSON.parse(localStorage.getItem('user')).id;
    },
    regularize() {
      return process.env.VUE_APP_REGULARIZE;
    }
  }
}
</script>

<style scoped>
.v-select__slot input {
  text-transform: uppercase;
}

.v-stepper__step--inactive .title-stepper {
  font-family: Roboto-Regular;
}

.v-stepper__step--active .title-stepper {
  color: #000 !important;
  font-family: Roboto-Bold;
  text-shadow: 0 0 0 0;
}

.title-modal {
  word-break: normal;
  text-align: center;
  margin: auto;
}

.paragraph-modal {
  text-align: center;
  font-size: 16px;
  padding: 0 20px;
}

.cabecalho {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.qrcode {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode .text {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  padding: 0 20px;
}

.qrcode .code {
  width: 100%;
  padding: 0 20px;
}

.qrcode .steps {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 20px;
  padding-top: 20px;
}

.qrcode .steps p {
  margin: unset;
}

.qrcode span {
  font-size: 16px;
  color: #3f3f3f;
  margin: unset;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

@media only screen and (max-width: 500px) {
  .theme--light.v-stepper {
    width: 90vw;
  }

  .v-stepper__content button {
    width: 100%;
    margin: 5px 0;
  }

  .btn-confirm, .btn-cancel {
    width: 100%;
    margin: 5px 0 !important;
    padding: 0;
  }

  .cabecalho {
    display: block;
    align-items: center;
    margin-bottom: 15px;
  }
}

</style>
